import { languageNames, useI18n, type Language } from './i18n';

export function LanguageSelector() {
  const { language, setLanguage, t } = useI18n();
  return <label className="language-selector"><span>{t('Sprache')}</span>
    <select data-testid="language-selector" aria-label={t('Sprache')} value={language} onChange={event => setLanguage(event.target.value as Language)}>
      {(['de', 'tr', 'en'] as const).map(code => <option key={code} value={code}>{languageNames[code]}</option>)}
    </select>
  </label>;
}
